// extracted by mini-css-extract-plugin
module.exports = {"link":"_3uZoj","root":"_3jVjy","label":"_2pGng"};